import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Briefcase, Lightbulb, CalendarCheck, Star } from "lucide-react";

export default function ManagerOverview() {
  const { user, profile } = useAuth();
  const [projects, setProjects] = useState([]);
  const [meetings, setMeetings] = useState([]);
  useEffect(() => {
    api.get("/projects/").then(r => setProjects(r.data || []));
    api.get("/meetings/").then(r => setMeetings(r.data || []));
  }, []);
  return (
    <div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Ciao, {user?.full_name?.split(" ")[0]}</h1>
      <p className="mt-1 text-slate-600">{profile?.title || ""}</p>
      <div className="mt-4 cxo-card p-4 flex items-center gap-3">
        <Badge className={`border-0 ${profile?.application_status === "approved" ? "bg-[#E9F8F1] text-[#1F9D6A]" : "bg-amber-100 text-amber-700"}`}>
          Stato candidatura: {profile?.application_status || "draft"}
        </Badge>
        {profile?.is_verified && <Badge className="bg-[#EAF0FF] text-[#2D6BFF] border-0">Profilo verificato</Badge>}
        <span className="text-sm text-slate-500 flex items-center gap-1 ml-auto"><Star size={14} className="text-[#B7791F]" fill="currentColor" /> {profile?.rating_average?.toFixed(1) || "—"}</span>
      </div>

      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[{l:"Progetti attivi", v: projects.filter(p => p.status === "active").length, i: Briefcase, link: "/manager/projects"},
          {l:"Incontri", v: meetings.length, i: CalendarCheck, link: "/manager/meetings"},
          {l:"Disponibilità", v: `${profile?.monthly_availability_days || 0}gg/mese`, i: Lightbulb, link: "/manager/profile"},
          {l:"Progetti completati", v: profile?.completed_projects || 0, i: Star, link: "/manager/projects"}].map((s, i) => {
          const Icon = s.i;
          return (
            <Link key={i} to={s.link}><div className="cxo-card p-5">
              <div className="flex items-center gap-2 text-slate-500"><Icon size={14} /><span className="text-xs uppercase tracking-wider font-semibold">{s.l}</span></div>
              <p className="mt-2 text-3xl font-display font-bold cxo-tabular text-slate-900">{s.v}</p>
            </div></Link>
          );
        })}
      </div>

      <div className="mt-6 cxo-card p-6">
        <h2 className="font-display text-lg font-semibold text-slate-900">Progetti recenti</h2>
        <div className="mt-4 space-y-3">
          {projects.slice(0, 3).map(p => (
            <Link key={p.id} to={`/manager/projects/${p.id}`} className="block cxo-card p-4 hover:bg-slate-50">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-slate-900">{p.title}</p>
                  <p className="text-xs text-slate-500">Azienda: {p.company?.company_name}</p>
                </div>
                <ArrowRight size={16} className="text-slate-400" />
              </div>
            </Link>
          ))}
          {!projects.length && <p className="text-sm text-slate-500">Nessun progetto al momento</p>}
        </div>
      </div>
    </div>
  );
}
